// ============================================================
// Terms & Conditions
// Static content page. Required for payment gateway compliance
// and general legitimacy.
// ============================================================

import React from 'react';

function Terms({ onBack }) {
  return (
    <div className="policy-page">
      <button className="link-button" onClick={onBack}>← Back</button>
      <h1>Terms & Conditions</h1>
      <p className="policy-updated">Last updated: July 2026</p>

      <p>By using CHART Rubric, you agree to the following terms. Please read them carefully before purchasing a report.</p>

      <h2>What CHART Rubric is</h2>
      <p>CHART Rubric is a behavioral readiness assessment built for GCC (Global Capability Centre) aspirants and professionals. It is a self-assessment tool based on your own answers to scenario-based questions, tailored by your career stage, industry, and current GCC status. It is not a technical skills test, a psychometric certification, a guarantee of employment, or a substitute for professional career or legal advice.

</p>

      <h2>Accuracy of your report</h2>
      <p>Your CHART Rubric report is generated based entirely on the answers you provide. We do not independently verify the accuracy of your responses. The insights and recommendations in your report are intended as guidance, not as definitive statements about your abilities or career prospects.</p>

      <h2>Payment and access</h2>
      <p>Payment is required to access the full 20-question assessment and receive your complete report. Once payment is confirmed and your assessment is submitted, your report is generated and made available to you immediately. Please see our Refund Policy for details on cancellations.</p>

      <h2>Acceptable use</h2>
      <p>You agree to use CHART Rubric for your own personal assessment only. You may not attempt to copy, redistribute, or resell the assessment questions, scoring methodology, or report content. You may not attempt to access or reverse-engineer the underlying system.</p>

      <h2>No guarantee of outcomes</h2>
      <p>CHART Rubric provides insight into behavioral patterns relevant to GCC environments. It does not guarantee that you will be hired, promoted, or achieve any specific career outcome. Your report is one input among many in your own career decisions.</p>

      <h2>Changes to these terms</h2>
      <p>We may update these terms from time to time. Continued use of CHART Rubric after changes are posted constitutes acceptance of the updated terms.</p>

      <h2>Contact</h2>
      <p>Questions about these terms can be sent to connect@sarthiedge.com.</p>
    </div>
  );
}

export default Terms;
